<template>
    <div class="dialogC" v-dialogDrag>
        <div class="el-dialog" style="width: 400px;border: 1px solid #3a8ee6;">
            <div class="el-dialog__header">
                <span class="el-dialog__title">AML剂量换算</span>
                <button type="button" @click="Close" class="el-message-box__headerbtn"><i
                        class="el-message-box__close el-icon-close"></i></button>
            </div>
            <div>
                <el-form :model="calculatorFrom" label-position="top" style="padding: 20px">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="身高(CM)">
                                <el-input v-model="calculatorFrom.height" @change="handelCal"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="体重(KG)">
                                <el-input v-model="calculatorFrom.weight" @change="handelCal"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="体表面积">
                                <el-input v-model="calculatorFrom.area"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div>
                                DNR
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="总剂量">
                                <el-input v-model="calculatorFrom.dnr_count" @change="handelCal"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="录入剂量">
                                <el-input v-model="calculatorFrom.dnr_input"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div>
                                Ara-C
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="总剂量">
                                <el-input v-model="calculatorFrom.araC_count" @change="handelCal"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="录入剂量">
                                <el-input v-model="calculatorFrom.araC_input"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div>
                                IDA
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="总剂量">
                                <el-input v-model="calculatorFrom.ida_count" @change="handelCal"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="录入剂量">
                                <el-input v-model="calculatorFrom.ida_input"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div>
                                HHT
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="总剂量">
                                <el-input v-model="calculatorFrom.hht_count" @change="handelCal"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="录入剂量">
                                <el-input v-model="calculatorFrom.hht_input"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div>
                                ACLA
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="总剂量">
                                <el-input v-model="calculatorFrom.acla_count" @change="handelCal"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="录入剂量">
                                <el-input v-model="calculatorFrom.acla_input"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="保留小数位数">
                                <el-input v-model="calculatorFrom.decimals" @change="handelCal"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["id"],
        data() {
            return {
                calculatorFrom: {
                    height: null,
                    weight: null,
                    area: null,
                    dnr_count: null,
                    dnr_input: null,
                    araC_count: null,
                    araC_input: null,
                    ida_count: null,
                    ida_input: null,
                    hht_count: null,
                    hht_input: null,
                    acla_count: null,
                    acla_input: null,
                    decimals: 5

                },
            }
        },
        methods: {
            Close() {
                this.$emit('close')
            },
            handelCal() {
                if (this.calculatorFrom.weight && this.calculatorFrom.height) {
                    this.calculatorFrom.area = 0.0061 * this.calculatorFrom.height + 0.0124 * this.calculatorFrom.weight - 0.0099
                }
                if (this.calculatorFrom.area && this.calculatorFrom.dnr_count) {
                    this.calculatorFrom.dnr_input = (this.calculatorFrom.dnr_count / 3 / this.calculatorFrom.area).toFixed(this.calculatorFrom.decimals)
                }
                if (this.calculatorFrom.area && this.calculatorFrom.araC_count) {
                    this.calculatorFrom.araC_input = (this.calculatorFrom.araC_count / 7 / this.calculatorFrom.area).toFixed(this.calculatorFrom.decimals)
                }
                if (this.calculatorFrom.area && this.calculatorFrom.ida_count) {
                    this.calculatorFrom.ida_input = (this.calculatorFrom.ida_count / 3 / this.calculatorFrom.area).toFixed(this.calculatorFrom.decimals)
                }
                if (this.calculatorFrom.area && this.calculatorFrom.hht_count) {
                    this.calculatorFrom.hht_input = (this.calculatorFrom.hht_count / 7 / this.calculatorFrom.area).toFixed(this.calculatorFrom.decimals)
                }
                if (this.calculatorFrom.acla_count) {
                    this.calculatorFrom.acla_input = this.calculatorFrom.acla_count / 7
                }
            },
        },
    };
</script>
<style scoped>
    .dialogC {
        z-index: 2000;
        position: absolute;
        top: 20px;
    }

    .dialogC /deep/ .el-form-item--mini .el-form-item__content, /deep/ .el-form-item--mini .el-form-item__label {
        line-height: 10px;
    }
</style>
